import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map, Observable } from 'rxjs';
import { RoleFeatureResponseModel, RoleResponseModel } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  constructor(private apiService: ApiService) {}

  getRoles(): Observable<RoleResponseModel> {
    return this.apiService.get('/users/roles').pipe(
      map(response => {
        return response;
      }),
    );
  }

  getRoleFeatures(roleId: number): Observable<RoleFeatureResponseModel[]> {
    return this.apiService.get(`/users/roles/${roleId}/features`).pipe(
      map(response => {
        return response;
      }),
    );
  }
}
